import { io } from "socket.io-client";
import { get_quickReplies } from "./dialogflowUtility";
import { setSessionItem } from "./chatUtility";
import { v4 as uuidv4 } from 'uuid';
const axios = require("axios");
// generate socketIOConnect.



async function socketIOConnect(socketIO, setAnchorEl, userName, setsocketIO, setsocketName, quickReplies) {
  if (socketIO === null) {
    setAnchorEl(null);
    let name = userName ? userName : uuidv4();
    try{
      const socket = io(process.env.REACT_APP_VAHUB_WEB_SOCKET_URL);  
      setsocketIO(socket);
      setsocketName(name);
      setSessionItem("socketName", name);
      setSessionItem("chatType", "socketIO");
      quickReplies = get_quickReplies([]);            
    } catch (error) {
      console.log(error)
    }  
  }
}

export { socketIOConnect };
